module.exports = __webpack_public_path__ + "static/media/logo.20d9536b.png";


//////////////////
// WEBPACK FOOTER
// ./public/logo.png
// module id = 105
// module chunks = 0